(function($, document) {
    $(document).ready(function () {
        
        $(".dropdown select").change(function (e) {
            let toggle  =$(this).parents(".dropdown").children(".dropdown-toggle");
            
            toggle.trigger("click.bs.dropdown");
        })
        
        $(".dropdown-menu").click(function (e) {
            let target = $(e.target);
            
            if (target.is("select")) {
                e.preventDefault();
                e.stopPropagation();                
            }
        })
    })
}(jQuery, document))